import { render, staticRenderFns } from "./goodsBase.vue?vue&type=template&id=78e0a094&scoped=true&"
import script from "./goodsBase.vue?vue&type=script&lang=js&"
export * from "./goodsBase.vue?vue&type=script&lang=js&"
import style0 from "./goodsBase.vue?vue&type=style&index=0&id=78e0a094&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e0a094",
  null
  
)

export default component.exports